import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './InvoiceAdvanceInfo.css';
import PageTitle from '../Layout/components/PageTitle';
import { Button, Breadcrumbs, Link, Typography, TextField, MenuItem, Dialog } from '@material-ui/core';
import { ADD, EDIT, VIEW, roleStr } from '../../common/common'
import { toMoney, validateEmail, getUrlParams } from '../../common/utils'
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';
import Toast from '../Layout/components/Toast';
import PTable from './components/PTable';
import Email from './components/Email';
import axios from 'axios';
import AlertDialog from '../Layout/components/AlertDialog';

class InvoiceAdvanceInfo extends PureComponent {
    constructor(props) {
        super(props);
        const invoiceId = getUrlParams("id");
        const invoiceState = getUrlParams("state");
        this.state = {
            showAlert: false,
            showCompleteAlert: false,
            openHtml: false,
            invoiceObj: null,
            id: invoiceId,
            state: parseInt(invoiceState),
            invoiceNumber: "",

            matterNumber: "",
            matterId: "",
            office: "",
            payer: "",
            contact_email: "",
            contact_name: "",
            contact_title: "",
            date: "",
            due_day: "",
            status: "",
            balance: 0,
            dueTimeData: [0, 7, 14, 30],
            emailHtml: "",

            total_deposite: "",
            total_discount: "",
            total_expenditure: "",
            total_payment: "",
            total_prepayment: "",
            total_service_fee: "",
            totalDueFee: 0,
            caseBalance: 0,

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleInvoiceComplete = this.handleInvoiceComplete.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSentStatus = this.handleSentStatus.bind(this);
        this.handleSendEmail = this.handleSendEmail.bind(this);
        this.handleSendEmailPreview = this.handleSendEmailPreview.bind(this);
        this.handleDownloadPDF = this.handleDownloadPDF.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.saveInvoice = this.saveInvoice.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleMarkAsSent = this.handleMarkAsSent.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
        this.handleReEdit = this.handleReEdit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }
    render() {
        const {
            showAlert,
            showCompleteAlert,
            showEditAlert,
            openHtml,
            invoiceObj,
            matterNumber,
            office,
            payer,
            contact_email,
            contact_name,
            date,
            due_day,
            invoiceNumber,
            status,
            balance,
            dueTimeData,
            emailHtml,

            total_payment,
            total_prepayment,
            totalDueFee,

            showToast,
            toastMsg,
            toastState,
        } = this.state;
        // 1、editing状态下：底部显示save invoice（balance的为0或小于0的时候自动变成complete按钮）、顶部Email Invoice两个按钮； 
        // 2、sent状态下：底部显示complete、顶部显示下载两个按钮
        // 3、complete状态下：底部显示save invoice按钮，顶部显示下载、sent
        const sentBtnView = () => {
            if (status !== "sent" && status !== "complete") {
                return <Button disabled={this.isDisabled()} className="btn mt-10" variant="outlined" color="primary" onClick={this.handleSentStatus}>Mark as Sent</Button>
            }
        }
        const footBtnView = () => {
            if (status === "complete" && !this.isDisabled()) {
                // return <Button className="btn" variant="contained" color="primary" onClick={this.handleInvoiceComplete}>save invoice</Button>
            } else if (status === "editing" && !this.isDisabled()) {
                if (balance <= 0) {
                    return <Button className="btn mt-10" variant="contained" color="primary" onClick={this.handleInvoiceComplete}>complete</Button>
                }
            } else if (status === "sent" && !this.isDisabled()) {
                return <Button className="btn mt-10" variant="contained" color="primary" onClick={this.handleInvoiceComplete}>complete</Button>
            }
        }
        // const editBtnView = () => {
        //     if (status === "complete" && state === VIEW) {
        //         return <Button className="btn mt-10" variant="outlined" color="primary" onClick={this.handleReEdit}>Reset to editing</Button>
        //     }
        // }
        return (
            <Root>
                <div className="head h">
                    <div className="v">
                        <PageTitle title={invoiceObj ? invoiceObj.number : ""} subtitle="MANAGEMENT"></PageTitle>
                    </div>
                </div>
                <div className={this.barColor(status, "stateBar")}></div>
                <div className="invoiceWapper">
                    <div className="pageTitle">ADVANCE INVOICE</div>
                    <div className="line"></div>
                    <div className="infoBody">
                        <div className="h h-t h-bt">
                            <div className="h h-t">
                                <div className="v v-r textWapper">
                                    <div className="h">
                                        <div className="textTitle">Matter</div>
                                        <TextField
                                            disabled={true}
                                            id="fmatter"
                                            className="textField"
                                            margin="dense"
                                            variant="outlined"
                                            onChange={e => this.handleChange(e, "matterNumber")}
                                            value={matterNumber}
                                            style={{ marginTop: 0 }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="h">
                                        <div className="textTitle">Office</div>
                                        <TextField
                                            disabled={true}
                                            id="office"
                                            className="textField"
                                            value={office}
                                            margin="dense"
                                            variant="outlined"
                                        />
                                    </div>
                                    <div className="h">
                                        <div className="textTitle">Payer</div>
                                        <TextField
                                            disabled={true}
                                            id="payer"
                                            className="textField"
                                            margin="dense"
                                            variant="outlined"
                                            placeholder="Payer name"
                                            onChange={e => this.handleChange(e, "payer")}
                                            value={payer}
                                        />
                                    </div>
                                    <div className="v v-r">
                                        <div className="h">
                                            <div className="textTitle">Contact</div>
                                            <Button disabled={this.isDisabled()} className="btn" variant="outlined" color="primary" onClick={this.handleClick}>Same as Client</Button>
                                        </div>
                                        <TextField
                                            disabled={this.isDisabled()}
                                            id="contactemail"
                                            className="textField"
                                            margin="dense"
                                            variant="outlined"
                                            placeholder="Email adress"
                                            onChange={e => this.handleChange(e, "contact_email")}
                                            onBlur={this.handleBlur}
                                            value={contact_email}
                                        />
                                        <TextField
                                            disabled={this.isDisabled()}
                                            id="fcontact"
                                            className="textField"
                                            margin="dense"
                                            variant="outlined"
                                            placeholder="Contact name"
                                            onChange={e => this.handleChange(e, "contact_name")}
                                            onBlur={this.handleBlur}
                                            value={contact_name}
                                        />
                                    </div>
                                </div>
                                <div className="v v-r textWapper">
                                    <div className="h">
                                        <div className="textTitle">Invoice</div>
                                        <TextField
                                            disabled={true}
                                            id="invoice"
                                            className="textField"
                                            margin="dense"
                                            variant="outlined"
                                            onChange={e => this.handleChange(e, "invoiceNumber")}
                                            value={invoiceNumber}
                                            style={{ marginTop: 0 }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="h">
                                        <div className="textTitle">Date</div>
                                        <TextField
                                            disabled={this.isDisabled()}
                                            id="date"
                                            type="date"
                                            variant="outlined"
                                            className="textField"
                                            value={date}
                                            margin="dense"
                                            onChange={e => this.handleChange(e, 'date')}
                                            onBlur={this.handleBlur}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="h">
                                        <div className="textTitle">Payment due</div>
                                        <TextField
                                            disabled={this.isDisabled()}
                                            id="text-dept"
                                            margin="dense"
                                            variant="outlined"
                                            className="textField"
                                            select
                                            value={due_day}
                                            onChange={e => this.handleSelect(e, 'due_day')}
                                            onBlur={this.handleBlur}
                                        >
                                            {dueTimeData.map((option, index) => (
                                                <MenuItem key={index} value={option}>
                                                    {this.paymentDueText(option)}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                    <div className="h">
                                        <div className="textTitle">Invoice status</div>
                                        <div className="status h">
                                            <div className={this.barColor(status, "stateBall")}></div>
                                            {status}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="info-r">
                                <div className="h h-r">
                                    <Button className="btn mr-10" variant="outlined" color="primary" onClick={this.handleDownloadPDF}>DOWNLOAD PDF</Button>
                                    <Button disabled={this.isDisabled()} className="btn" variant="outlined" color="primary" onClick={this.handleSendEmailPreview}>EMAIL INVOICE</Button>
                                </div>
                                {sentBtnView()}
                                {footBtnView()}
                                {/* {editBtnView()} */}
                                <div className="v v-r detailed">
                                    <div>Advance Legal Fee: ${total_prepayment ? toMoney(total_prepayment) : "0.00"}</div>
                                    <div>Received Payment: ${total_payment ? toMoney(total_payment) : "0.00"}</div>
                                    {/*<div>Discounts: ${total_discount ? toMoney(total_discount) : "0.00"}</div>*/}
                                    <div className="line2"></div>
                                    <div className="total">Total Due: ${this.totalDue(totalDueFee)}</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="title2">ADVANCE LEGAL FEE</div>
                            <PTable
                                type="prepayment"
                                keyName="prepayments"
                                invoiceObj={invoiceObj}
                                saveInvoice={this.saveInvoice}
                                isDisabled={this.isDisabled()}
                            />
                            <div className="title2">RECEIVED PAYMENT</div>
                            <PTable
                                type="payment"
                                keyName="payments"
                                invoiceObj={invoiceObj}
                                saveInvoice={this.saveInvoice}
                                isDisabled={this.isDisabled()}
                            />
                            {/*<div className="title2">DISCOUNT</div>*/}
                            {/*<PTable*/}
                            {/*type="discount"*/}
                            {/*keyName="discounts"*/}
                            {/*invoiceObj={invoiceObj}*/}
                            {/*saveInvoice={this.saveInvoice}*/}
                            {/*isDisabled={this.isDisabled()}*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>
                <Dialog maxWidth={false} open={openHtml}>
                    <Email
                        toEmail={contact_email}
                        emailHtml={emailHtml}
                        contactName={contact_name}
                        handleSendEmail={this.handleSendEmail}
                        handleCancel={this.handleCloseDialog}
                    />
                </Dialog>
                <AlertDialog
                    open={showAlert}
                    content="Whether to mark as sent status?"
                    yesLabel="cancel"
                    noLabel="yes"
                    handleAlertYes={this.handleMarkAsSent}
                    handleAlertNo={this.handleCloseDialog}
                ></AlertDialog>
                <AlertDialog
                    open={showCompleteAlert}
                    content="Whether marked as complete?"
                    yesLabel="cancel"
                    noLabel="yes"
                    handleAlertYes={this.handleComplete}
                    handleAlertNo={this.handleCloseDialog}
                ></AlertDialog>
                <AlertDialog
                    open={showEditAlert}
                    content="Whether marked as editing?"
                    yesLabel="cancel"
                    noLabel="yes"
                    handleAlertYes={this.handleEdit}
                    handleAlertNo={this.handleCloseDialog}
                ></AlertDialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }
    componentDidMount() {
        this.getInvoiceData(() => {
            this.initData();
        });
        // this.getInvoice(() => {
        //     this.initData();
        // })
    }
    initData() {
        const { invoiceObj } = this.state;
        const invoiceNumber = invoiceObj.number;
        const matterArr = invoiceObj.matter;
        const matterObj = matterArr[0];
        const matterNumber = matterObj.number;
        const matterId = matterObj.id;
        const caseBalance = matterObj.case.balance;
        const office = this.getOffice(matterObj);
        const payer = this.extractPayer(matterObj.case.client);
        const contact_name = invoiceObj.contact_name ? invoiceObj.contact_name : "";
        const contact_email = invoiceObj.contact_email ? invoiceObj.contact_email : "";
        const contact_title = invoiceObj.contact_title ? invoiceObj.contact_title : "";

        const date = this.getNowDate(invoiceObj.date);
        const due_time = invoiceObj.due_time ? this.getNowDate(invoiceObj.due_time) : "";
        const due_day = this.diffDay(date, due_time);
        const status = invoiceObj.status;

        const rateData = matterObj.handler;
        const balance = invoiceObj.balance ? invoiceObj.balance : 0;

        this.countTotalFee();

        this.setState(() => ({
            invoiceNumber,
            matterNumber,
            matterId,
            office,
            payer,
            contact_name,
            contact_email,
            contact_title,
            date,
            due_day,
            status,
            caseBalance,

            rateData,
            balance,
        }));
    }
    countTotalFee() {
        const { invoiceObj } = this.state;
        const total_prepayment = invoiceObj.total_prepayment ? invoiceObj.total_prepayment : 0;
        const total_payment = invoiceObj.total_payment ? invoiceObj.total_payment : 0;
        const total_discount = invoiceObj.total_discount ? invoiceObj.total_discount : 0;
        const totalDueFee = total_prepayment - total_discount - total_payment;
        this.setState(() => ({
            total_discount,
            total_payment,
            total_prepayment,
            totalDueFee,
        }))
    }
    handleInvoiceComplete() {
        this.setState(() => ({
            showCompleteAlert: true
        }));
    }
    handleReEdit() {
        this.setState(() => ({
            showEditAlert: true
        }));
    }
    handleBlur(e) {
        this.saveInvoice();
    }
    handleSentStatus() {
        this.setState(() => ({
            showAlert: true
        }))
    }
    handleMarkAsSent() {
        const invoiceId = this.state.invoiceObj.id;
        const params = {
            invoice_type: "advance",
            status: "sent"
        }
        this.editInvoice(invoiceId, params);
    }
    handleComplete() {
        const { matterId, totalDueFee } = this.state;
        this.closeDialog();
        if (totalDueFee > 0) {
            this.showToast("Sorry, this invoice cannot be completed when due is still greater than zero.", "error");
            return;
        }
        const invoiceId = this.state.invoiceObj.id;
        const params = {
            invoice_type: "advance",
            matter_id: matterId,
            status: "complete"
        }
        this.editInvoice(invoiceId, params);
        // this.updateCaseBalance();
    }
    // 当invoice balance = 0， transfer = Payment(Received)
    // 当invoice balance < 0， transfer = Payment(Received)
    updateCaseBalance() {
        const { invoiceObj, totalDueFee, caseBalance } = this.state;
        let transfer = 0;
        const invoiceBalance = totalDueFee;
        const payment = invoiceObj.total_payment ? invoiceObj.total_payment : 0;
        const case_id = invoiceObj.matter[0].case.id;
        if (invoiceBalance === 0 || invoiceBalance < 0) {
            transfer = payment;
        }
        const value = caseBalance + transfer;
        console.log("caseBalance", caseBalance)
        console.log("transfer", transfer)
        console.log("case balance + transfer", value)
        this.setCaseBalance(case_id, value);
    }
    handleEdit() {
        const { matterId, invoiceObj } = this.state;
        const params = {
            invoice_type: "advance",
            matter_id: matterId,
            status: "editing"
        }
        const invoiceId = invoiceObj.id;
        this.editInvoice(invoiceId, params);
    }
    handleClick(e) {
        const { invoiceObj } = this.state;
        const matterArr = invoiceObj.matter;
        const matterObj = matterArr[0];
        const clientObj = matterObj.case.client;
        let contact_name = "";
        let contact_email = "";
        if (clientObj.individual) {
            contact_name = clientObj.individual.first_name + " " + clientObj.individual.last_name;
            contact_email = clientObj.individual.email;
        } else if (clientObj.corporation) {
            const contact = clientObj.corporation.points_of_contact;
            if (contact.length > 0) {
                contact_name = contact[0].name;
                contact_email = contact[0].email;
            }
        }
        this.setState({
            contact_email,
            contact_name,
        }, () => {
            this.saveInvoice();
        });
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value,
        }))
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleSendEmail(content, pdf_content, ccList) {
        const { invoiceObj } = this.state;
        const params = {
            invoice_id: invoiceObj.id,
            subject: "Your bill from MT Law",
            content,
            pdf_content
        }
        if (ccList.length > 0) params["cc"] = ccList;
        this.sendEmail(params, () => {
            this.closeDialog();
            this.saveInvoice();
        });
    }
    handleSendEmailPreview(e) {
        const { invoiceObj, contact_email } = this.state;
        let msg = "";
        if (contact_email === "") {
            msg = "Please input the email address";
            this.showToast(msg, "warning");
            return;
        } else if (!validateEmail(contact_email)) {
            msg = "Please enter the correct email address";
            this.showToast(msg, "warning");
            return;
        }
        this.setState(() => ({
            openHtml: true,
        }));
        this.sendEmailView(invoiceObj.id);
    }
    handleDownloadPDF(e) {
        const invoiceId = this.state.invoiceObj.id
        this.download(invoiceId);
    }
    handleCloseDialog() {
        this.closeDialog();
    }
    closeDialog() {
        this.setState(() => ({
            openHtml: false,
            showAlert: false,
            showCompleteAlert: false,
            showEditAlert: false,
        }));
    }
    isDisabled() {
        const { state, status } = this.state;
        if (state === ADD) {
            return false;
        } else if (state === VIEW || status === "complete") {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    getNowDate(dateStr = null) {
        let date = null;
        if (dateStr) {
            date = new Date(dateStr);
        } else {
            date = new Date();
        }
        let dateString = new Date(date.getTime()).toISOString().split("T")[0];
        // let dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split("T")[0];
        return dateString;
    }
    paymentDueText(num) {
        if (num === 0) return "Due on receipt";
        return num;
    }
    barColor(status, styleName) {
        if (status === "complete") {
            return styleName + " colorGreen";
        } else if (status === "editing") {
            return styleName + " colorBlue";
        } else if (status === "sent") {
            return styleName + " colorYellow";
        }
    }
    extractPayer(clientObj) {
        if (clientObj) {
            if (clientObj.individual) {
                return clientObj.individual.first_name + " " + clientObj.individual.last_name;
            } else if (clientObj.corporation) {
                return clientObj.corporation.name;
            }
        }
        return "";
    }
    getOffice(matterObj) {
        if (!matterObj.handler) return "";
        if (!matterObj.handler[0]) return "";
        if (!matterObj.handler[0].team) return "";
        if (!matterObj.handler[0].team.dept_info) return "";
        return matterObj.handler[0].team.dept_info.office;
    }
    dayToTimestamp(day) {
        const { date } = this.state;
        const dayTimestamp = day * 3600 * 24;
        const dateTimestamp = (Date.parse(date) / 1000);
        const newTimestamp = dateTimestamp + dayTimestamp;
        return newTimestamp.toString();
    }
    diffDay(fDate, lDate) {
        if (fDate && lDate) {
            const fDateT = new Date(fDate);
            const lDateT = new Date(lDate);
            const diffT = lDateT - fDateT;
            const day = Math.floor(diffT / 86400000);
            return day;
        }
        return 0;
    }
    saveInvoice() {
        const {
            matterId,
            date,
            due_day,
            payer,
            contact_email,
            contact_name,
            invoiceObj,
        } = this.state;
        const params = {
            invoice_type: "advance",
            matter_id: matterId,//int
            date: (Date.parse(date) / 1000).toString(),//str
            due_time: this.dayToTimestamp(due_day),//str
            payer: payer,//str
            contact_email: contact_email,//str
            contact_name: contact_name,//str
        }
        console.log("saveInvoice", params)
        const invoiceId = invoiceObj.id;
        this.editInvoice(invoiceId, params);
        // this.props.history.push({ pathname: '/main/invoice' });
    }
    totalDue(totalDueFee) {
        if (totalDueFee < 0) {
            return "(" + toMoney(Math.abs(totalDueFee)) + ")";
        } else {
            return toMoney(totalDueFee)
        }
    }
    //-----------request-------------
    getInvoiceData(callback = null) {
        const id = getUrlParams('id');
        instance.get(BASE_URL + roleStr() + `/billing/invoices/${id ? id : 0}`).then((res) => {
            const invoiceObj = res.data.data;
            this.setState({
                invoiceObj
            }, () => {
                if (callback) callback();
            })
        })
    }
    getInvoice() {
        const { invoiceObj } = this.state;
        if (invoiceObj) {
            let params = {
                invoice_id: invoiceObj.id ? invoiceObj.id : null
            }
            instance.get(BASE_URL + roleStr() + '/billing/invoices', { params }).then((res) => {
                const invoiceData = res.data.data;
                const invoiceObj = invoiceData[0];
                console.log("重载后的", invoiceObj)
                localStorage.setItem('invoiceObj', JSON.stringify(invoiceObj));
                this.setState({
                    invoiceObj: JSON.parse(localStorage.getItem('invoiceObj'))
                }, () => {
                    this.initData();
                });
                this.setState(() => ({
                    invoiceObj: JSON.parse(localStorage.getItem('invoiceObj'))
                }));
            })
        }
    }
    editInvoice(invoiceId, params) {
        instance.put(BASE_URL + "" + roleStr() + "/billing/invoices/" + invoiceId, params).then((res) => {
            this.getInvoiceData();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    setCaseBalance(case_id, balance) {
        const params = {
            balance,
        }
        instance.put(BASE_URL + roleStr() + '/cases/' + case_id, params).then((res) => {
            console.log("updatecase", res)
            // this.showToast("Successfully modified", "success");
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    sendEmail(params, callback) {
        instance.post(BASE_URL + "billing/email", params).then((res) => {
            this.showToast("Sent successfully", "success");
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    sendEmailView(invoice_id) {
        instance.post(BASE_URL + "billing/invoices/" + invoice_id + "/preview").then((res) => {
            // this.showToast("Sent successfully", "success");
            const emailHtml = res.data.data.html;
            this.setState(() => ({
                emailHtml
            }))
        })
    }
    // download(invoice_id) {
    //     instance.post(BASE_URL + "billing/invoices/" + invoice_id + "/download").then((res) => {
    //         // this.showToast("Sent successfully", "success");
    //         console.log(res.data)
    //         this.downloadHistory(res)
    //     })
    // }
    download(invoice_id) {
        axios({
            url: BASE_URL + "billing/invoices/" + invoice_id + "/download",
            method: 'post',
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
            }
        }).then(function (res) {
            var blob = new Blob([res.data], { type: res.headers['content-type'] });
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = 'invoice.pdf'; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
        }).catch(function () {
        })
    }

}

export default withRouter(InvoiceAdvanceInfo);